import { useCountryOptions } from '@e3dc-react/shell/Hooks/useCountryOptions'
import { Box, Stack } from '@mui/material'
import React from 'react'
import { TextField } from 'src/Libs/inputs/formik'
import Select from 'src/Libs/inputs/formik/Select'
import { useAddressForm } from '../../hooks'

/**
 * Component for company address used in installation statement.
 * It requires formik context for the input fields.
 */
const CompanyAddress: React.VFC = () => {
  const { companyAddressForm } = useAddressForm()
  const { allCountries } = useCountryOptions()

  return (
    <Stack spacing={4}>
      <TextField
        required={companyAddressForm.companyName.required}
        name={companyAddressForm.companyName.name}
        label={companyAddressForm.companyName.label}
        disabled
      />
      <TextField
        required={companyAddressForm.addressAndHouseNumber.required}
        name={companyAddressForm.addressAndHouseNumber.name}
        label={companyAddressForm.addressAndHouseNumber.label}
        disabled
      />
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <Box sx={{ pr: 2 }}>
          <TextField
            required={companyAddressForm.zipCode.required}
            name={companyAddressForm.zipCode.name}
            label={companyAddressForm.zipCode.label}
            disabled
          />
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <TextField required={companyAddressForm.city.required} name={companyAddressForm.city.name} label={companyAddressForm.city.label} disabled />
        </Box>
      </Box>
      <Select
        required={companyAddressForm.country.required}
        name={companyAddressForm.country.name}
        label={companyAddressForm.country.label}
        options={allCountries}
        isSearchable
        disabled
      />
    </Stack>
  )
}

export default CompanyAddress
